<template>
  <div class="phone-index" ref="phoneIndex" :class="[industryBool?'hiddenY':'']">
    <transition enter-active-class="animated fadeInRight" leave-active-class="animated slideOutLeft">
      <industry-list v-if="industryBool" @industryBool="industryBoolVal"></industry-list>
    </transition>
    <div class="top" :class="[scrollClass]">
      <div class="posRe">
        <div class="type" @click="industryListFun"><p>行业</p><p>分类</p></div>
        <i class="icon-img icon-search-white" @click="searchFun"></i>
      </div>
    </div>
    <pan :state="state"></pan>
    <div class="center">
      <div class="industry-list">
        <template v-if="industryList&&industryList.length">
          <template v-for="(list,index) in industryList">
            <div :class="['industry-list'+index]" @click="industryFun(list)" :key="'industryList'+index">
              <div>
                <div :class="['icon-img industry'+list.id]"></div>
                <p>{{list.name}}</p>
              </div>
            </div>
          </template>
        </template>
        <div :class="['industry-list'+industryList.length]" @click="goMap">
          <div>
            <div class="icon-img industry-map"></div>
            <p>进入地图</p>
          </div>
        </div>
      </div>
      <pTitle class="title-top" :title="titleRecommend"></pTitle>
      <list class="" :list-url="RecommendUrl" class-name="Recommend"></list>
      <pTitle class="" :title="titleNew"></pTitle>
      <div class="">
        <list :list-url="newUrl" class-name="New"></list>
      </div>
    </div>
    <page-footer></page-footer>
  </div>
</template>

<script>
import pan from '@/components/Phone/pan'
import pTitle from '@/components/title'
import list from '@/components/Phone/list'
import industryList from '@/components/Phone/industryList'
import pageFooter from '@/components/footer'
export default {
  name: 'phoneIndex',
  props: [''],
  data () {
    return {
      titleRecommend: {
        title: '<span>推荐</span>全景'
      },
      titleNew: {
        title: '<span>最新</span>全景'
      },
      RecommendUrl: 'PanoWebService.asmx/GetRecommendByCity',
      newUrl: 'PanoWebService.asmx/GetLatestByCity',
      industryList: [],
      parameter: {
        cityId: 0,
        topIndex: -1,
        cityIndex: -1,
        countyIndex: -1
      },
      industryBool: false,
      scrollClass: '',
      state: 0
    }
  },
  components: {
    pan: pan,
    pTitle: pTitle,
    list: list,
    industryList: industryList,
    pageFooter: pageFooter
  },
  created () {
    let that = this;
    document.title = '魅力'+(that.$realmNameId==50?'重庆':'四川')
    that.$nextTick(function () {
      let b = that.$refs.phoneIndex
      b.addEventListener('scroll', this.handleScroll)
    })
    this.$emit('topState', 0)
    that.publicJs.changeDocumentTitle()
  },
  mounted () {
    this.industryData()
  },
  methods: {
    handleScroll: function () { // 页面滚动一定的位置
      let that = this
      let b = that.$refs.phoneIndex
      let scrollTop = b.pageYOffset || b.scrollTop
      if (scrollTop > 344) {
        if (!that.scrollClass) that.scrollClass = 'scroll-top'
      } else {
        that.scrollClass = ''
      }
    },
    searchFun: function () {
      let that = this
      that.$router.push({
        path: '/searchIndex',
        query: {
          key: that.publicJs.encode(JSON.stringify({
            typeId: 0,
            keyWords: '',
          })),
          '_': new Date().getTime()
        }
      })
    },
    industryBoolVal: function (val) {
      let that = this;
      that.industryBool = val
    },
    industryListFun: function () {
      let that = this;
      that.industryBool = true
    },
    industryFun: function (item) {
      let that = this;
      that.$router.push({
        path: '/phoneIndustryIndex',
        query: {
          key: that.publicJs.encode(JSON.stringify({
            cityId: 0,
            typeId: item.id||0,
          })),
          '_': new Date().getTime()
        }
      })
    },
    industryData: function () {
      let that = this;
      that.publicJs.navGetData(function (data) {
        if (data.code === 1) {
          that.industryList = data.data.concat(that.industryList)
        }
      })
    },
    goMap: function () {
      let that = this
      that.$router.push({
        path: '/phoneMapIndex',
        query: {
          key: that.publicJs.encode(JSON.stringify({
            cityId: 0,
            typeId: 0
          })),
          '_': new Date().getTime()
        }
      })
    }
  },
  destroyed () {
    let that = this;
    let b = that.$refs.phoneIndex
    if (b) {
      b.addEventListener('scroll', this.handleScroll)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .top{
    position: absolute;
    top:0;
    left: 0;
    width: 100%;
    z-index: 4;
    background-color: rgba(0,0,0,0.2);
    padding: 11px 17px 11px 11px;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
  }
  .top.scroll-top{
    /*background-color: #248DDF;*/
  }
  .top>div{
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 12px;
    color: #FFFFFF;
    line-height: 14px;
  }
  .top .type p{
    border-bottom: 1px solid #fff;
  }
  .top .type{
    cursor: pointer;
  }
  .icon-search-white{
    width: 20px;
    height: 20px;
    cursor: pointer;
    background-position:-257px -208px;
  }

  .industry-list{
    display: flex;
    flex-wrap: wrap;
    flex: 1;
    flex-direction: row;
  }
  .industry-list>div{
    width: 25%;
    font-size: 12px;
    color: #000000;
    padding-bottom: 15px;
  }
  .industry-list>div>div{
    width: 62px;
    text-align: center;
  }
  .industry-list>.industry-list0>div,
  .industry-list>.industry-list4>div,
  .industry-list>.industry-list8>div{
    margin-left: 0;
  }
  .industry-list>.industry-list3>div,
  .industry-list>.industry-list7>div,
  .industry-list>.industry-list11>div{
    width: 62px;
    margin-left: auto;
  }
  .industry-list>.industry-list1>div,
  .industry-list>.industry-list5>div,
  .industry-list>.industry-list9>div{
    margin-left:20%;
  }
  .industry-list>.industry-list2>div,
  .industry-list>.industry-list6>div,
  .industry-list>.industry-list10>div{
    margin-left:40%;
  }

  .industry-list .icon-img{
    width: 40px;
    height: 40px;
    border-radius: 40px;
  }
  .industry-list .industry8{
    background-position: -59px -66px;
  }
  .industry-list .industry1{
    background-position: -109px -66px;
  }
  .industry-list .industry3{
    background-position: -160px -66px;
  }
  .industry-list .industry10{
    background-position: -217px -66px;
  }
  .industry-list .industry7{
    background-position: -59px -136px;
  }
  .industry-list .industry6{
    background-position: -110px -136px;
  }
  .industry-list .industry-map{
    width: 40px;
    height: 40px;
    background-position: -217px -136px;
    box-shadow: 0px 0px 5px 0px rgba(187, 41, 62, 0.73);
    border-radius: 8px;
  }
  .center{
    padding:1.25rem 0.6875rem 0.5rem;
  }
  .title-top{
    margin-top: 20px;
  }
  .list{
    margin:0 -6px;
  }
  @media (max-width:500px) {
    .industry-list>.industry-list1>div,
    .industry-list>.industry-list5>div,
    .industry-list>.industry-list9>div{
      margin-left:15%;
    }
    .industry-list>.industry-list2>div,
    .industry-list>.industry-list6>div,
    .industry-list>.industry-list10>div{
      margin-left:30%;
    }
  }
  @media (max-width:400px) {
    .industry-list>.industry-list1>div,
    .industry-list>.industry-list5>div,
    .industry-list>.industry-list9>div{
      margin-left:10%;
    }
    .industry-list>.industry-list2>div,
    .industry-list>.industry-list6>div,
    .industry-list>.industry-list10>div{
      margin-left:20%;
    }
  }
</style>



// WEBPACK FOOTER //
// src/Phone/index.vue